import { ActionTree } from "vuex";
import { ExecYearmonthState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<ExecYearmonthState, RootState> = {};
